import httpService from "core/services/httpService";

import API_URL from "core/constants/api/apiUrl";

const campaignService = {
    getAll(data, signal){
        return httpService.get({
            url: API_URL.GET_CAMPAIGNS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return {
                data: value.item2,
                total: value.item1
            };
        })
    },

    createCampaign(data, signal){
        return httpService.post({
            url: API_URL.CREATE_CAMPAIGN,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    getLandings(data, signal){
        return httpService.get({
            url: API_URL.GET_CAMPAIGN_LANDINGS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return value
        })
    },

    addLanding(data, signal){
        return httpService.post({
            url: API_URL.ADD_CAMPAIGN_LANDING,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    deleteLanding(data, signal){
        return httpService.delete({
            url: API_URL.DELETE_CAMPAIGN_LANDING,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    getMobileUrls(data, signal){
        return httpService.get({
            url: API_URL.GET_CAMPAIGN_MOBILE_URLS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return value
        })
    },

    addMobileUrl(data, signal){
        return httpService.post({
            url: API_URL.ADD_CAMPAIGN_MOBILE_URL,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    deleteMobileUrl(data, signal){
        return httpService.delete({
            url: API_URL.DELETE_CAMPAIGN_MOBILE_URL,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    getAffiliates(data, signal){
        return httpService.get({
            url: API_URL.GET_CAMPAIGN_AFFILIATES,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return value
        })
    },

    addAffiliates(data, signal){
        return httpService.post({
            url: API_URL.ADD_CAMPAIGN_AFFILIATES,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    deleteAffiliate(data, signal){
        return httpService.delete({
            url: API_URL.DELETE_CAMPAIGN_AFFILIATE,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },
}

export default campaignService;